<template>
	<div class="container">
	<div class="nav" >
		<ul class="content mCustomScrollbar" data-mcs-theme="minimal" style="position: relative;height: 400px;">
			<li class="item t1 on" title="青花贯耳瓷尊">
				<i></i>
				<em></em>
				<span><img style="width: 30%; height: 40%; position: absolute; top: 30%; left: 35%;" src="../assets/gczp/images/1.png" alt=""></span>
			</li>
			<li class="item t2" title="乾隆开光瓷尊">
				<i ></i>
				<em></em>
				<span><img style="width: 30%; height: 40%; position: absolute; top: 30%; left: 35%;" src="../assets/gczp/images/2.png" alt=""></span>
			</li>
			<li class="item t3" title="粉彩人物瓷瓶">
				<i ></i>
				<em></em>
				<span><img style="width: 30%; height: 40%; position: absolute; top: 30%; left: 35%;" src="../assets/gczp/images/3.png" alt=""></span>
			</li>
			<li class="item t4" title="粉彩丹凤朝阳瓷盆">
				<i ></i>
				<em></em>
				<span><img style="width: 30%; height: 40%; position: absolute; top: 30%; left: 35%;" src="../assets/gczp/images/4.png" alt=""></span>
			</li>
		</ul>
	</div>
	<div class="box">
		<div class="p p1 show">
			<span class="name">
				<span style="text-align: left;writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family: cursive;width: 30px;line-height: 30px;font-size: 1em;">器身与口颈部分割套接而成，侈口，长束颈，折肩，弧腹，圈足。通体施满白釉，绘青花。青花从口到底约九层，主要有海浪纹、缠枝菊花纹、回纹、蝠纹、莲瓣纹等，以缠枝菊花纹为主题纹饰。装饰繁复，但繁而不乱，层次分明，视觉美观，为乾隆时期青花瓷中的精品</span>
				<span style="writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family:cursive;border-left:1px solid #007AFF;width: 30px;font-size: 30px;height: 100%; padding: 0 20px;">青花贯耳瓷尊</span>
			</span>
			<img src="../assets/gczp/images/1.png" alt="">
		</div>
		<div class="p p2">
			<span class="name">
				<span style="text-align: left;writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family: cursive;width: 30px;line-height: 30px;font-size: 1em;">瓷质，直颈，鼓腹，高足，肩饰铺首环。通体施黑色底釉上挂蓝斑釉，采用浅浮雕描金技法，颈部饰蕉叶纹，腹部饰蛟龙。腹部两面圆形开光，前开光内饰粉彩双鹅，后开光内绘一对鹌鹑。器底圈足内挂黑釉蓝斑，并有“大清乾隆年制”六字篆书阳文刻款。</span>
				<span style="writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family:cursive;border-left:1px solid #007AFF;width: 30px;font-size: 30px;height: 100%; padding: 0 20px;">乾隆开光瓷尊</span>
			</span>
			<img src="../assets/gczp/images/2.png" alt="">
		</div>
		<div class="p p3">
			<span class="name">
				<span style="text-align: left;writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px; writing-mode: vertical-rl;font-family: cursive;width: 30px;line-height: 30px;font-size: 1em;">瓷质，侈口，长颈，圆腹，圈足。通体施白底釉，口沿外一周绘红彩八蝠及黒彩璎珞纹，腹部用五彩绘寿星、琴棋、松树图。瓶底圈足内挂白釉，并盖有篆书“大清乾隆年制”六字朱红印章款。器物造型规整，白色底釉洁净明快，色彩艳丽，人物绘画造型准确，神态栩栩如生。</span>
				<span style="writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family:cursive;border-left:1px solid #007AFF;width: 30px;font-size: 30px;height: 100%; padding: 0 20px;">粉彩人物瓷瓶</span>
			</span>
			<img src="../assets/gczp/images/3.png" alt="">
		</div>
		<div class="p p4">
			<span class="name">
				<span style="text-align: left;writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family: cursive;width: 30px;line-height: 30px;font-size: 1em;">器形宽折沿、略鼓腹、圈足。瓷胎挂釉透明，器内粉彩三层纹，第一层口沿用双沟剔花填彩缠枝菊花纹装饰；第二层腹内一圈粉彩饰荷花鸳鸯纹；第三层内底绘牡丹垂尾立凤。盆外腹部为三组朱红草叶纹。器物造型硕大而规整，纹饰布局参差感较强烈。盆底主纹垂尾立凤象征着和平、安宁、幸福和祥瑞。</span>
				<span style="writing-mode: vertical-lr; writing-mode: tb-rl;letter-spacing: 3px;font-family:cursive;border-left:1px solid #007AFF;width: 30px;font-size: 30px;height: 100%; padding: 0 20px;">粉彩丹凤朝阳瓷盆</span>
			</span>
			<img src="../assets/gczp/images/4.png" alt="">
		</div>
	</div>
</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		mounted(){
			if(location.href.indexOf("#reloaded")==-1){
		        location.href=location.href+"#reloaded";
		        location.reload();
		    };
			this.handleSearch();
	    },
		methods:{
			handleSearch(){
				$(function () {
					$('.nav li').on('click', function () {
					    $(this).addClass('on').siblings().removeClass('on');
					    $('.p').eq($(this).index()).addClass('show').siblings().removeClass('show');
					})
				})
			}
		}
	}
</script>

<style scoped>
*{
	list-style: none;
}
.container {
max-width: 1920px;
min-width: 1200px;
height: 973px;
background: url(../assets/gczp/images/bg.jpg) no-repeat;
position: relative;
margin-left: auto;
margin-right: auto;
}
.box {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.box .p {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.box .p img, .box .p .name {
  position: absolute;
  bottom: 150px;
  transition: all 1s ease;
}
.box .p1 img {
  left: 450px;
  opacity: 0;
  transform: translateX(20%);
}
.box .p2 img {
  left: 450px;
  opacity: 0;
  transform: translateX(20%);
}
.box .p3 img {
  left: 450px;
  opacity: 0;
  transform: translateX(20%);
}
.box .p4 img {
  left: 450px;
  opacity: 0;
  transform: translateX(20%);
}
.box .p1.show img, .box .p2.show img, .box .p3.show img, .box .p4.show img {
  opacity: 1;
  transform: translateX(0);
}
.box .p1 .name {
  position: absolute;
  width: 305px;
  height: 413px;
  left: 108px;
  transform: translateX(-20%);
  opacity: 0;
  bottom: 275px;
  /*background: url(../assets/gczp/images/sprite.png) no-repeat -274px 0px;*/
}
.box .p2 .name {
  position: absolute;
  width: 293px;
  height: 407px;
  left: 186px;
  bottom: 275px;
  transform: translateX(-20%);
  opacity: 0;
  /*background: url(../assets/gczp/images/sprite.png) no-repeat 0px -421px;*/
}
.box .p3 .name {
  position: absolute;
  width: 277px;
  height: 408px;
  left: 186px;
  bottom: 275px;
  transform: translateX(-20%);
  opacity: 0;
  /*background: url(../assets/gczp/images/sprite.png) no-repeat -585px 0px;*/
}
.box .p4 .name {
  position: absolute;
  width: 268px;
  height: 415px;
  left: 186px;
  bottom: 275px;
  transform: translateX(-20%);
  opacity: 0;
  /*background: url(../assets/gczp/images/sprite.png) no-repeat 0px 0px;*/
}
.box .p1.show .name, .box .p2.show .name, .box .p3.show .name, .box .p4.show .name {
  opacity: 1;
  transform: translateX(0);
}
.nav {
  position: absolute;
  width: 150px;
  top: 200px;
  right: 200px;
  z-index: 2;
  border: 2px solid #777777;
}
.nav li {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 1px auto 0;
  cursor: pointer;
  transition: all .6s linear;
}
.nav li img {
  position: absolute;
  top: 0;
  left: 0;
  width: 129px;
  height: 129px;
}
.nav li i {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: opacity .6s linear;
}
.nav li.t1 i {
  background: url(../assets/gczp/images/6.png) no-repeat center;
}
.nav li.t2 i {
  background: url(../assets/gczp/images/6.png) no-repeat center;
}
.nav li.t3 i {
  background: url(../assets/gczp/images/6.png) no-repeat center;
}
.nav li.t4 i {
  background: url(../assets/gczp/images/6.png) no-repeat center;
}
.nav li em {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity .6s linear;
}
.nav li.t1 em {
	
  background: url(../assets/gczp/images/6-1.png) no-repeat center;
}
.nav li.t2 em {
  background: url(../assets/gczp/images/6-1.png) no-repeat center;
}
.nav li.t3 em {
  background: url(../assets/gczp/images/6-1.png) no-repeat center;
}
.nav li.t4 em {
  background: url(../assets/gczp/images/6-1.png) no-repeat center;
}
.nav li.on {
  width: 129px;
  height: 129px;
}
.nav li.on i {
  opacity: 0;
}
.nav li.on em {
  opacity: 1;
}
</style>




// WEBPACK FOOTER //
// src/pages/vr.vue